import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { push } from 'connected-react-router';

import { withIntl } from 'HOC/withIntl';
import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import shouldSubmit from 'utilities/shouldSubmit';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';

import config from 'config/index';

import UpdatePinForm from '../components/PinForm';

import { selectDetailPending, selectPinForUpdate } from '../services/selectors';
import { updatePinRequest, pinsDetailRequest } from '../services/actions';
import { forms, requiredFields, localizableFields } from '../services/config';

const form = forms.updatePinForm;

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(values, requiredFields, intl.formatMessage({ id: 'error.required' }));

const onSubmit = (data, dispatch, { intl, match: { params } }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableFields, confirmMessage)) {
        dispatch(updatePinRequest(form, params.id, data));
    }
};

export default compose(
    withIntl,
    connect(
        (state, { match: { params } }) => ({
            initialValues: selectPinForUpdate(state, { id: params.id }),
            showLoader: selectDetailPending(state),
        }),
        (dispatch, { match: { params } }) => ({
            read: () => {
                dispatch(pinsDetailRequest(params.id));
            },
            cancel: () => {
                dispatch(push(config.routes.pins));
            },
        }),
    ),
    routeDependencies(),
    loadable,
    reduxForm({
        form,
        validate,
        onSubmit,
        enableReinitialize: true,
    }),
)(UpdatePinForm);
